export namespace Permissions {
  export namespace Projects {
    export const View = 'Permissions.Projects.View';
    export const Create = 'Permissions.Projects.Create';
    export const Edit = 'Permissions.Projects.Edit';
    export const Delete = 'Permissions.Projects.Delete';
    export const Dashboard = 'Permissions.Projects.Dashboard';
  }
  export namespace DonorsManagement {
    export const View = 'Permissions.DonorsManagement.View';
    export const ExportExcel = 'Permissions.DonorsManagement.ExportExcel';
  }

    export namespace KioskVideos {
    export const View = 'Permissions.KioskVideos.View';
    export const Create = 'Permissions.KioskVideos.Create';
    export const Edit = 'Permissions.KioskVideos.Edit';
    export const Delete = 'Permissions.KioskVideos.Delete';
  }
  export namespace Kiosks {
    export const View = 'Permissions.Kiosks.View';
    export const Create = 'Permissions.Kiosks.Create';
    export const Edit = 'Permissions.Kiosks.Edit';
    export const Delete = 'Permissions.Kiosks.Delete';
  }
  export namespace Notifications {
    export const View = 'Permissions.Notifications.View';
    export const Create = 'Permissions.Notifications.Create';
    export const Edit = 'Permissions.Notifications.Edit';
    export const Delete = 'Permissions.Notifications.Delete';
  }
  export namespace AboutUs {
    export const View = 'Permissions.AboutUs.View';
    export const Create = 'Permissions.AboutUs.Create';
    export const Edit = 'Permissions.AboutUs.Edit';
    export const Delete = 'Permissions.AboutUs.Delete';
  }

  export namespace Banks {
    export const View = 'Permissions.Banks.View';
    export const Create = 'Permissions.Banks.Create';
    export const Edit = 'Permissions.Banks.Edit';
    export const Delete = 'Permissions.Banks.Delete';
  }

  export namespace ContactUs {
    export const View = 'Permissions.ContactUs.View';
    export const Edit = 'Permissions.ContactUs.Edit';
    export const Delete = 'Permissions.ContactUs.Delete';
  }
// added new 
  export namespace CarouselImages {
    export const View = 'Permissions.CarouselImages.View';
    export const Create = 'Permissions.CarouselImages.Create';
    export const Edit = 'Permissions.CarouselImages.Edit';
    export const Delete = 'Permissions.CarouselImages.Delete';
  }






}
